const POSTBACK_ENDPOINT = "https://postback-manager.dev.gc-internal.net";

export enum PostbackManagerEvents {
  AppLaunch,
  Retention,
}

export interface Payload {
  [key: string]: any;
}

export class PostbackManager {
  readonly key: string;
  constructor(key: string) {
    this.key = key;
  }

  async sendEvent(
    eventName: PostbackManagerEvents,
    entryPayload: Payload,
    meta?: { [key: string]: string }
  ): Promise<Response> {
    // transitioning from _UA_adNetwork to $adNetworkName as of 2021-01-28
    if (!entryPayload._UA_adNetwork && !entryPayload.$adNetworkName) {
      return Promise.reject(
        new Error("No $adNetworkName found in the payload")
      );
    }

    const eventNameString =
      eventName === PostbackManagerEvents.AppLaunch
        ? "applaunch"
        : eventName === PostbackManagerEvents.Retention
        ? "retention"
        : "unknown";

    return fetch(`${POSTBACK_ENDPOINT}/postback?key=${this.key}`, {
      method: "post",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify({ entryPayload, eventName: eventNameString, meta }),
    }).then((response) => {
      if (response.status > 400) {
        const error = new Error(response.statusText);
        (error as any).code = response.status;
        return Promise.reject(error);
      }
      return response;
    });
  }
}
